<template>
  <b-container fluid class="the-results">
    <b-row align-h="between">
      <h1 class="pageheading">{{ $t('standards.titles.list') }}</h1>
      <b-col cols="auto">
        <b-button
          variant="success"
          @click="createStandards">
          {{ $t('myCertificates.toolbar.new') }}
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="auto">
        <b-button-toolbar>
          <b-button-group v-if="selectedStandards.length > 0">
            <b-button
              variant="danger"
              @click="deleteStandards">
              {{ $t('myCertificates.toolbar.delete') }}
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </b-col>
    </b-row>
    <b-row class="the-results__filterbar">
      <b-form inline>
        <b-form-input
          v-model="filter.standard"
          :placeholder='$t("standards.labels.standard")'>
        </b-form-input>
      </b-form>
      <div class="bubble">
        <span> {{ totalPages }} {{ $t('common.hits') }} </span>
      </div>
    </b-row>
    <b-row class="the-results__list">
      <b-table
        selectable
        select-mode="single"
        @row-selected="updateStandards"
        striped
        borderless
        hover
        @sort-changed="sortingChanged"
        :no-local-sorting="true"
        stacked="sm"
        :items="items"
        :fields="fields"
        id="resultlist">
        <template slot="HEAD_select">
          <b-form-checkbox
            @change="checkAll"
            v-model="selectedAll">
          </b-form-checkbox>
        </template>
        <template slot="select" slot-scope="scope">
          <b-form-checkbox
            :value="scope.item.id"
            v-model="selectedStandards"
          ></b-form-checkbox>
        </template>
      </b-table>
    </b-row>
    <b-row class="the-results__toolbar">
      <b-container fluid class="toolbar">
        <b-row align-h="center">
          <b-col>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalPages"
              :per-page="perPage"
              @input="fetchNextPage">
            </b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </b-row>
    <b-row align-h="between">
      <b-col cols="auto">
        <b-button-toolbar>
          <b-button-group v-if="selectedStandards.length > 0">
            <b-button
              variant="danger"
              @click="deleteStandards">
              {{ $t('myCertificates.toolbar.delete') }}
            </b-button>
          </b-button-group>
        </b-button-toolbar>
      </b-col>
      <b-col cols="auto">
        <b-button
          variant="success"
          @click="createStandards">
          {{ $t('myCertificates.toolbar.new') }}
        </b-button>
      </b-col>
    </b-row>
    <b-modal
      @ok="handleDeleteOk"
      id="delete_request"
      ref="delete_request">
      <template slot="modal-header">
        <span>{{ $t('owner.modal.title') }}</span> <br>
      </template>
      <template slot="default">
        <span>{{ $t('owner.modal.text') }}</span>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { applyRule } from '../services/request'
export default {
  name: 'TheStandardsList',
  data () {
    return {
      totalPages: 1,
      perPage: 25,
      filter: {
        standard: ''
      },
      sorting: {
        sortBy: '',
        orderBy: ''
      },
      selectedStandards: [],
      selectedAll: false,
      currentPage: 1,
      fields: [
        { key: 'select', label: '' },
        { key: 'standard', label: this.$t('standards.labels.standard'), sortable: true, class: 'productname' }
      ],
      items: []
    }
  },
  mounted () {
    this.fetch({ page: this.currentPage })
  },
  computed: {
    ...mapGetters('common/standards', ['standards'])
  },
  watch: {
    /**
     * @param data
     * @param meta
     *
     * @return {void}
     */
    standards ({ data, meta }) {
      const { pagination } = meta

      this.items = data
      this.totalPages = pagination.total
      this.perPage = pagination.per_page
    },
    filter: {
      /**
       *
       * @param inputs
       *
       * @return {void}
       */
      handler: function (inputs) {
        let query = { search: 1, ...inputs }

        applyRule(query, 'length:3')

        this.fetch({
          query: Object.keys(Object.deleteEmpty(query)).length === 1 ? {} : query
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('common/standards', ['fetch']),
    /**
     *
     * @return {Promise}
     */
    async sortingChanged ({ sortBy, sortDesc }) {
      this.sorting.orderBy = sortDesc ? 'desc' : 'asc'
      this.sorting.sortBy = sortBy

      let query = { search: 1, ...this.filter }

      applyRule(query, 'length:3')

      await this.fetch({
        ...this.sorting,
        query: Object.keys(Object.deleteEmpty(query)).length === 1 ? {} : query
      })
    },
    /**
     *
     * @return {Promise}
     */
    async fetchNextPage () {
      const sorting = this.sorting.orderBy && this.sorting.sortBy ? this.sorting : null

      await this.fetch({
        page: this.currentPage,
        query: Object.keys(Object.deleteEmpty(this.filter)).length === 1 ? {} : this.filter,
        ...sorting
      })
    },
    /**
     *
     * @return {void}
     */
    updateStandards (items) {
      this.$router.push(`/standards/${items[0].id}/update`)
    },
    /**
     *
     * @return {void}
     */
    createStandards () {
      this.$router.push({ path: '/standards' })
    },
    /**
     * @returns {void}
     */
    checkAll (state) {
      this.selectedStandards = state ? this.items.map(item => item.id) : []
    },
    /**
     * @param trigger
     *
     * @return {void}
     */
    async handleDeleteOk ({ trigger }) {
      if (trigger !== 'ok') {
        return
      }

      for (let id of this.selectedStandards) {
        await this.$api.delete('standards', id)
      }

      this.selectedStandards = []
      this.selectedAll = false

      await this.fetch({ page: this.currentPage })
    },
    deleteStandards () {
      this.$refs['delete_request'].show()
    }
  }
}
</script>
